import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Confidentialite() {
  return (
    <LegalShell title="Politique de confidentialité (RGPD)" lastUpdated="6 février 2026" testId="page-rgpd">
      <p>Cette politique décrit comment Student Hub collecte, utilise et protège tes données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.</p>

      <h2>1. Responsable du traitement</h2>
      <p><strong>Jamira LHASSANI</strong>, entrepreneur individuel, SIRET 422 541 649 00022. Pour toute question relative à la protection de tes données : <strong>contact.servicedecomdu64@gmail.com</strong>.</p>

      <h2>2. Données collectées</h2>
      <ul>
        <li><strong>Compte</strong> : email, nom/pseudo, mot de passe (haché bcrypt).</li>
        <li><strong>Activité</strong> : démarches cochées, démarches personnelles ajoutées, documents uploadés, posts communautaires.</li>
        <li><strong>Paiement</strong> : numéro de transaction, statut, montant. <em>Aucune donnée carte bancaire n'est stockée par Student Hub</em> (Stripe / PayPal sont seuls dépositaires).</li>
        <li><strong>Technique</strong> : adresse IP (anti-brute force), user-agent, cookies essentiels.</li>
      </ul>

      <h2>3. Finalités</h2>
      <ul>
        <li>Fournir le Service (authentification, suivi des démarches, stockage de documents).</li>
        <li>Gérer les abonnements et la facturation.</li>
        <li>Envoyer des emails opérationnels (réinitialisation, digest hebdo si tu as activé l'option).</li>
        <li>Sécuriser la plateforme (rate limit, détection d'abus).</li>
      </ul>

      <h2>4. Bases légales</h2>
      <ul>
        <li>Exécution du contrat (CGU) pour la fourniture du Service.</li>
        <li>Consentement pour les emails marketing / digest.</li>
        <li>Intérêt légitime pour la sécurité.</li>
        <li>Obligation légale pour la conservation des factures (10 ans).</li>
      </ul>

      <h2>5. Durées de conservation</h2>
      <ul>
        <li>Données de compte : tant que le compte est actif, puis 30 jours après suppression (anonymisation).</li>
        <li>Documents : supprimés sur demande à tout moment ou à la suppression du compte.</li>
        <li>Données de facturation : 10 ans (obligation comptable).</li>
        <li>Logs de sécurité (IP, tentatives d'auth) : 12 mois.</li>
      </ul>

      <h2>6. Destinataires</h2>
      <p>Tes données ne sont jamais vendues. Sous-traitants utilisés :</p>
      <ul>
        <li><strong>MongoDB / Emergent</strong> (hébergement) — UE / Espace économique européen</li>
        <li><strong>Stripe</strong> (paiements) — Irlande</li>
        <li><strong>PayPal</strong> (paiements, à venir) — Luxembourg</li>
        <li><strong>Resend</strong> (envoi d'emails transactionnels) — UE/US (Standard Contractual Clauses)</li>
      </ul>

      <h2>7. Tes droits</h2>
      <p>Conformément au RGPD, tu disposes des droits suivants :</p>
      <ul>
        <li><strong>Accès</strong> : obtenir une copie de tes données via <code>GET /api/me/export</code> (depuis ton espace).</li>
        <li><strong>Rectification</strong> : modifier tes informations à tout moment.</li>
        <li><strong>Effacement (« droit à l'oubli »)</strong> : supprimer ton compte via la page Paramètres.</li>
        <li><strong>Portabilité</strong> : récupérer tes données dans un format réutilisable (JSON).</li>
        <li><strong>Opposition</strong> : refuser certains traitements (digest, leaderboard).</li>
        <li><strong>Réclamation</strong> : auprès de la CNIL (<a href="https://www.cnil.fr" target="_blank" rel="noreferrer">cnil.fr</a>).</li>
      </ul>

      <h2>8. Sécurité</h2>
      <ul>
        <li>Mots de passe hachés (bcrypt).</li>
        <li>Authentification par cookies httpOnly + SameSite=None + Secure.</li>
        <li>Limitation de débit (rate limiting) sur les endpoints sensibles.</li>
        <li>Protection brute-force (verrou IP+email après 5 tentatives en 15 min).</li>
        <li>Communications chiffrées HTTPS / TLS.</li>
      </ul>

      <h2>9. Cookies</h2>
      <p>Voir la <a href="/legal/cookies">Politique cookies</a> détaillée.</p>

      <h2>10. Mineurs</h2>
      <p>Le Service est destiné aux étudiants de 18 ans et plus. Si tu as entre 15 et 18 ans, un consentement parental est requis (article 8 RGPD).</p>

      <h2>11. Contact</h2>
      <p>Pour exercer tes droits ou toute question : <strong>contact.servicedecomdu64@gmail.com</strong>. Délai de réponse : 30 jours maximum.</p>
    </LegalShell>
  );
}
